export default __webpack_public_path__ + "static/media/Researching-amico.b78a81a3.svg";